import type { AgentAttributionTransactionMeta } from '@atlaskit/editor-common/transaction-agent-attribution';
import type { DiffStepAttribution } from '@atlaskit/editor-plugins/show-diff/show-diff-plugin-type';
import { fg } from '@atlaskit/platform-feature-flags/fg';

import type { Suggestion } from '../../aiSuggestionsPluginType';
import { CONTENT_REVIEWER_AGENT_KEY } from './api';

const CONTENT_REVIEWER_AGENT_NAME = 'Content Reviewer';

/** The suggestions API omits the OOTB agent's external config reference, so recover its known key. */
export function getSuggestionAgentNamedId(suggestion: Suggestion): string | undefined {
	return fg('content_reviewer_agent') &&
		suggestion.createdByAgent?.name === CONTENT_REVIEWER_AGENT_NAME
		? CONTENT_REVIEWER_AGENT_KEY
		: undefined;
}

/** Builds the actor metadata consumed by show-diff for each suggestion step. */
export function getSuggestionDiffStepAttribution(
	suggestion: Suggestion,
): DiffStepAttribution | undefined {
	const agentId = suggestion.createdByAgent?.accountId;
	if (!agentId) {
		return undefined;
	}

	const agentNamedId = getSuggestionAgentNamedId(suggestion);
	return {
		agentId,
		agentType: suggestion.createdByAgent?.agentType ?? undefined,
		...(agentNamedId ? { agentNamedId } : {}),
	};
}

/** Older suggestions omit the agent profile, but their content is still AI-authored. */
export function getSuggestionAgentAttribution(
	suggestion: Suggestion,
): AgentAttributionTransactionMeta {
	const agentNamedId = getSuggestionAgentNamedId(suggestion);

	return {
		agentId: suggestion.createdByAgent?.accountId || undefined,
		agentName: suggestion.createdByAgent?.name || undefined,
		agentType: suggestion.createdByAgent?.agentType || 'convo-ai',
		...(agentNamedId ? { agentNamedId } : {}),
	};
}
